import React from 'react';
import { connect } from 'react-redux';
import { Section, Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import IncomeForm from '../Form';
import { createTransactionIncome } from '@common/resources/Transaction/actions';
import { useIntl } from 'react-intl';

const Create = (props) => {
	const { createTransactionIncome, visible, onCancel } = props;
	const intl = useIntl();

	const handleSubmit = (data) => {
		return createTransactionIncome(data)
			.then((response) => {
				popIn(
					'success',
					intl.formatMessage({
						id: 'message.success.income.create',
						defaultMessage:
							'A new Income has been successfully created',
					})
				);

				onCancel && onCancel();
			})
			.catch((err) => Promise.reject(err));
	};

	return (
		<Modal visible={visible} onCancel={() => onCancel && onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.new.income',
					defaultMessage: 'Create Income',
				})}
			</Title>
			<Section className="mb-5">
				<IncomeForm onSubmit={handleSubmit} {...props} />
			</Section>
		</Modal>
	);
};

const mapStateToProps = ({
	items,
	modules,
	cellGroup,
	event,
	facility,
	ministry,
	mission,
	organization,
	prayer,
	testimony,
	service,
}) => {
	return {
		items,
		modules,
		cellGroup,
		event,
		facility,
		ministry,
		mission,
		organization,
		prayer,
		testimony,
		service,
	};
};

export default connect(mapStateToProps, {
	createTransactionIncome,
})(Create);
